import React from 'react';
import './DiversifySection.css';

function DiversifySection() {
  return (
    <section className="diversify-section">
      <div className="container">
        <div className="diversify-content">
          <h2 className="diversify-heading">Diversificamos nuestras inversiones</h2>
          <p className="diversify-text">
            El Grupo Tabia gestiona un patrimonio inmobiliario de 390 millones de euros y continúa desarrollando un perfil de inversión diversificado en distintos sectores.
          </p>
        </div>
      </div>
    </section>
  );
}

export default DiversifySection;
